import React, { createContext, useState } from "react";

const SideBarActiveContext = createContext("create");

const SideBarActiveProvider = ({ children }) => {
  const [currentSideBarActive, setCurrentSideBarActive] = useState("create");

  return (
    <SideBarActiveContext.Provider
      value={{ currentSideBarActive, setCurrentSideBarActive }}
    >
      {children}
    </SideBarActiveContext.Provider>
  );
};

export { SideBarActiveProvider, SideBarActiveContext };
